export const API_PATH_ApiDeviceMgmtLocationDelete = '/services/devices-mgtm/apiDeviceMgmtLocationDelete';
